/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import { Link, useLocation } from "react-router";
import Icon from "@/src/components/Icon/Icon";
import IconCivilLaw from "@/src/assets/iconsRedesign2026/civilLaw/toggleable/IconCivilLaw";
import { FC } from "react";
import { IconRenderProps } from "@/src/types/IconRenderProps";
import { SvgIconComponent } from "@mui/icons-material";
import { mergeSx } from "@/src/utils/mergeSx";
import { authenticatedNavigationStyle } from "@/src/components/AuthenticatedNavigation/authenticatedNavigationStyle";

export type AuthenticatedNavigationLinkDefaultProps = (
  | {
      type: "customIcon";
      icon: FC<IconRenderProps>;
    }
  | {
      type: "muiIcon";
      icon: SvgIconComponent;
    }
) & {
  label: string;
  to: string;
  iconColor?: string;
};

export default function AuthenticatedNavigationLinkDefault({ to, type, label, icon: IconComp, iconColor }: AuthenticatedNavigationLinkDefaultProps) {
  const location = useLocation();

  return (
    <ListItemButton
      component={Link}
      to={to}
      sx={mergeSx(authenticatedNavigationStyle.link, location.pathname === to && authenticatedNavigationStyle.linkActive, { margin: "0.25rem 0" })}
    >
      <ListItemIcon sx={{ marginRight: "0.5rem" }}>
        {type === "customIcon" ? <Icon icon={IconComp} fill={iconColor} /> : <IconComp sx={{ color: iconColor }} />}
      </ListItemIcon>
      <Typography component={"span"} variant={"cardTitle"}>
        {label}
      </Typography>
    </ListItemButton>
  );
}
